module.exports = __webpack_public_path__ + "static/media/IconHeartVoiceLong.9cbea4d1.svg";